<template>
  <div class="cuerpo">
    <Trade />
  </div>
</template>
<script>
// @ is an alias to /src
import Trade from "@/components/Trade.vue";

export default {
  name: "TradeView",
  components: {
    Trade,
  },
};
</script>

<style></style>
